import type {z} from "zod";

import {ListRepresentativesQueryParams} from "@project/sdk/sales/zod";

export const listRepresentativesSearchSchema = ListRepresentativesQueryParams.extend({
  page: ListRepresentativesQueryParams.shape.page.catch(1).default(1),
  perPage: ListRepresentativesQueryParams.shape.perPage.catch(20).default(20),
  q: ListRepresentativesQueryParams.shape.q.catch(undefined),
  sortKey: ListRepresentativesQueryParams.shape.sortKey.catch("representativeId"),
  sortDir: ListRepresentativesQueryParams.shape.sortDir.catch("asc").default("asc"),
  state: ListRepresentativesQueryParams.shape.state.catch("ACTIVE"),
  contractStatus: ListRepresentativesQueryParams.shape.contractStatus.catch("ALL"),
  countryCodes: ListRepresentativesQueryParams.shape.countryCodes.catch(undefined),
  exclusive: ListRepresentativesQueryParams.shape.exclusive.catch(undefined),
  createdFrom: ListRepresentativesQueryParams.shape.createdFrom.catch(undefined),
  createdBefore: ListRepresentativesQueryParams.shape.createdBefore.catch(undefined),
});

export type ListRepresentativesSearchInput = z.input<typeof listRepresentativesSearchSchema>;
export type ListRepresentativesSearch = z.output<typeof listRepresentativesSearchSchema>;
